import { yup } from '@framework/validation';
import { isObject } from 'lodash';
import { ExpressionType } from '../../IExpression';
import { createExpressionType } from '../../IExpressionType';
import { ExpressionValue } from '../../evaluate/ExpressionValue';
import { expressionLogger } from '../../utils/expressionLogger';
import { ReferenceSchema } from '../../validation/ReferenceSchema';
import { IReferenceExpression } from './IReferenceExpression';

export const ReferenceExpressionType =
  createExpressionType<IReferenceExpression>({
    type: ExpressionType.Reference,
    schema: yup.object({
      type: yup.string().exact(ExpressionType.Reference).required(),
      value: ReferenceSchema.label('Campo di riferimento')
        .default(null)
        .required(),
    }),
    evaluate(expression, scope) {
      const value = scope.getReference(expression.value);

      if (Array.isArray(value) && value.length > 0 && isObject(value[0])) {
        expressionLogger.warn(`Reference value is an array of objects, be careful in evaluation`, expression, scope); // prettier-ignore
        return value;
      }

      return value as ExpressionValue;
    },
    getReferences(expression) {
      return [expression.value];
    },
    toString(expression, toString) {
      return `@${expression.value.code}`;
    },
  });
